import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installWebVitals } from "@/lib/uxMetrics";


// Legacy .html URL compatibility: strip trailing .html so old links
// (e.g. /testimonials.html, /nl/referenties.html) resolve to SPA routes.
(() => {
  const { pathname, search, hash } = window.location;
  if (pathname.endsWith(".html") && pathname !== "/index.html") {
    const cleaned = pathname.slice(0, -".html".length) || "/";
    try {
      sessionStorage.setItem("legacyHtmlRedirect", pathname + search + hash);
    } catch {
      /* storage disabled – notice will simply be skipped */
    }
    window.history.replaceState(null, "", cleaned + search + hash);
  }
})();


createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

installWebVitals();

